"use client";

import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

export function ForumPanels({
  children,
  thread,
}: {
  children: React.ReactNode;
  thread: React.ReactNode;
}) {
  const pathname = usePathname();
  if (pathname.startsWith("/forum/team/")) {
    return <>{children}</>;
  }

  const hasSelectedThread = pathname !== "/forum";

  return (
    <main className="grid min-h-[calc(100svh-64px)] bg-[#F7F5EF] md:grid-cols-[360px_minmax(0,1fr)]">
      <section
        className={cn(
          "min-w-0 border-r border-[#D8C99B]/60 bg-[#FCFBF8]",
          hasSelectedThread ? "hidden md:block" : "block",
        )}
      >
        {children}
      </section>
      <section
        className={cn(
          "min-w-0 bg-[linear-gradient(180deg,#F7F5EF_0%,#FCFBF8_100%)]",
          hasSelectedThread ? "block" : "hidden md:block",
        )}
      >
        {thread}
      </section>
    </main>
  );
}
